import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=59d9f8f9&scoped=true&"
import script from "./AreaEdit.vue?vue&type=script&lang=js&"
export * from "./AreaEdit.vue?vue&type=script&lang=js&"
import style0 from "./AreaEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AreaEdit.vue?vue&type=style&index=1&id=59d9f8f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9f8f9",
  null
  
)

export default component.exports